<div *ngIf="modalData.name === 'openProjectActivity'">
  <div class="row">
    <div class="col-md-10">
      <button mat-raised-button color="primary"  id="modal-cancel-button" (click)="openCreateActivity()">
        Add Project Activity
    </button>

    </div>

  <div class="col-md-2">

    <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
      <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
    </span>
  </div>

  </div>
  <div style="background: #232d38;" >
    <div class="demo" >
      <div class="container">
          <!-- <div class="row justify-content-center">
          </div> -->

          <div class="row justify-content-center" >
            <h1 class="heading-title">Project Activity Timeline</h1>

              <div class="col-md-12" >
                  <div class="main-timeline" *ngIf="sortedItems.length > 0">
                      <div class="timeline " *ngFor="let activity of sortedItems">
                          <div class="timeline-content">
                              <span class="date">
                                  <span class="day"></span>
                                  <span class="month">{{activity.dateCreated | date}}</span>
                                  <span class="year"></span>
                              </span>
                              <h2 class="title">{{activity.ProjectActivityName}}</h2>
                              <p class="description">{{activity.ProjectActivityDescription}}</p>
                          </div>
                      </div>


                  </div>
              </div>
          </div>

      </div>
  </div>



  </div>
  <mat-dialog-actions align="center">


    <!-- <button mat-raised-button  id="modal-cancel-button" (click)="closeModal()">
        Go back
    </button> -->

    </mat-dialog-actions>
</div>
